"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.linkExp = /((http|https)\:\/\/)?([a-zA-Z0-9\-\.]+\.[a-zA-Z]{2,4}(\?[a-zA-Z0-9\-\_\&\=]+)?)(\/\S*)?/;
function parseMessage(text) {
    var matched = text.match(exports.linkExp);
    if (matched && matched[1]) {
        return text.replace(exports.linkExp, "<a href=\"" + matched[0] + "\">" + matched[0] + "</a>");
    }
    else if (matched) {
        return text.replace(exports.linkExp, "<a href=\"//" + matched[0] + "\">" + matched[0] + "</a>");
    }
    return text;
}
exports.parseMessage = parseMessage;
//# sourceMappingURL=utils.js.map